export default "__VITE_ASSET__CY2jIWpa__"